<template>
  <div class="banner">
    <div class="module">
      <div class="logo"></div>
      <div class="btn-home" @click="goToHome"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToHome() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  max-width: 1920px;
  min-width: 1600px;
  height: 441px;
  background: url('~@/assets/img/bg_page_banner.jpg') no-repeat;
  background-position: center;
}

.module {
  position: relative;
  width: 1600px;
  height: 100%;
}

.logo {
  position: absolute;
  top: 20px;
  left: 40px;
  width: 222px;
  height: 126px;
  background: url('~@/assets/img/logo.png') no-repeat;
}

.btn-home {
  position: absolute;
  top: 21px;
  right: 130px;
  width: 179px;
  height: 52px;
  background: url('~@/assets/img/btn_home.png') no-repeat;
  cursor: pointer;
}
</style>